/** Roles accordion group for Hired Equipment submissions and vendor master. */
export const HIRED_EQUIPMENT_MODULE = 'Hired Equipment';

/**
 * Submission workflow (`submission:hired_equipment_*` / `he_manage` / `he_revisions`)
 * plus vendor-master (`heMaster:*`) keys shown together in Roles.
 */
export function isHiredEquipmentFeaturePermission(key: string): boolean {
  return (
    key.startsWith('submission:hired_equipment_') ||
    key === 'submission:he_manage' ||
    key === 'submission:he_revisions' ||
    key.startsWith('heMaster:')
  );
}

/** Roles UI group name — remaps HE keys even if the API still returns an older module. */
export function displayModuleForPermission(key: string, fallbackModule: string): string {
  if (isHiredEquipmentFeaturePermission(key)) {
    return HIRED_EQUIPMENT_MODULE;
  }
  return fallbackModule;
}
